import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { FaceSmileIcon } from "@heroicons/react/24/solid";
import { Settings } from "lucide-react";
// import vid from "./images/set.mp4";
// const vid = require("./images/set.mp4")

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* <App /> */}
    <div className="h-screen w-full bg-white z-99 flex justify-center items-center flex-col gap-3">
      {/* <video
        src={vid}
        autoPlay="true"
        className="size-24 animate-bounce duration-1000 delai-1000"
      ></video> */}

      <Settings
        size={50}
        className="animate-spin duration-2500 delay-2500 text-blue-600 font-bold"
      />

      <h1 className="text-6xl font-bold text-center text-aquatic-400 ">
        Unavailable web site
      </h1>
      <p className="text-xl text-center">
        Please contact the developers staff for a maintenance of this web site!
      </p>
      <span className="font-bold text-center">
        lfdservices.com | 2026 | Douala
      </span>
    </div>
  </React.StrictMode>
);
